export default __webpack_public_path__ + "static/media/evcharger4.f632b47e.jpg";